export const UPDATE_PERSONAL_INFO = 'UPDATE_PERSONAL_INFO';
export const UPDATE_PERSONAL_INFO_SUCCESS = 'UPDATE_PERSONAL_INFO_SUCCESS';
export const UPDATE_PERSONAL_INFO_FAILURE = 'UPDATE_PERSONAL_INFO_FAILURE';
export const SET_PERSONAL_INFO_FORM_DIRTY = 'SET_PERSONAL_INFO_FORM_DIRTY';
export const CREATE_PROFILE_SAVE_BILLING_ADDRESS = 'CREATE_PROFILE_SAVE_BILLING_ADDRESS';

export const SUBMIT_CREATE_PROFILE = 'SUBMIT_CREATE_PROFILE';
export const SUBMIT_CREATE_PROFILE_SUCCESS = 'SUBMIT_CREATE_PROFILE_SUCCESS';
export const SUBMIT_CREATE_PROFILE_FAILURE = 'SUBMIT_CREATE_PROFILE_FAILURE';
export const SET_USPS_ADDRESS_OVERRIDE_ACCEPTED = 'SET_USPS_ADDRESS_OVERRIDE_ACCEPTED';
